export default {
  mounted () {
    /*
        * Only load Hotjar 10% of the time, to try preserving user data for times we
        * don't really use all the traffic. Which means the user can download less
        * stuff, and our performance be better.
        */
    if (Math.random() < 0.5) {
      this.$gtm.push({ event: 'loadHotjar' })
    }
  },
}
